import React, { Component } from 'react';
import PropTypes from 'prop-types';
import TagHideButton from './TagHideButton';
import { Popover } from 'frontend-component-library';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Button } from 'react-bootstrap';

import * as actions from 'actions';
import { selectTagSummary } from 'selectors';

class TagInfo extends Component {
  handleClick = () => {
    this.props.addTagFilter(this.props.tag);
  };
  render() {
    const {
      tag,
      count,
      isOpen,
      parentNode,
      closeInfoWindow,
      topRecommendationsTotal,
      tag: { name, displayClass, description },
    } = this.props;
    const tagCountText = `${count} result${
      count > 1 ? 's' : ''
    } in top ${topRecommendationsTotal}`;
    const className = `TagInfo ${displayClass}`;
    return (
      <Popover
        closePopover={closeInfoWindow}
        parentNode={parentNode}
        isOpen={isOpen}
        className={className}
      >
        <Popover.Title closePopover={closeInfoWindow}>
          <div className="TagInfo-header">
            <Button
              bsStyle="link"
              className="TagInfo-title"
              onClick={this.handleClick}
            >
              {name}
              <svg
                className="TagInfo-title-chevron"
                width="8"
                height="12"
                viewBox="0 0 8 12"
              >
                <path
                  d="M 1.41 0L 1.52588e-07 1.41L 4.58 6L 1.52588e-07 10.59L 1.41 12L 7.41 6L 1.41 0Z"
                  transform="translate(0.589844 0)"
                />
              </svg>
            </Button>
            <span className="TagInfo-count">{tagCountText}</span>
          </div>
        </Popover.Title>

        <p className="TagInfo-description">{description}</p>
        <TagHideButton tag={tag} />
      </Popover>
    );
  }
}

TagInfo.propTypes = {
  tag: PropTypes.shape({
    id: PropTypes.number,
    count: PropTypes.number,
    name: PropTypes.string,
    schema: PropTypes.string,
    displayClass: PropTypes.string,
  }).isRequired,
  count: PropTypes.number.isRequired,
};

TagInfo.defaultProps = {
  onAlert: () => null,
};

function mapStateToProps(state, props) {
  const tagSummary = selectTagSummary(state, props.tag);
  return {
    count: tagSummary.count || 0,
    topRecommendationsTotal: state.entities.summaries.topRecommendationsTotal,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      addTagFilter: actions.addTagFilter,
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(TagInfo);



// WEBPACK FOOTER //
// ./src/Components/Pages/Results/Tags/TagInfo.js